import React from "react";
import { useTranslation } from "react-i18next";
import { getAdminTabMetricColumns } from "../../config/adminTabMetricColumns";
import type { AdminHotelMetricRow } from "../../types/adminHotelMetricTable";
import { AdminHotelsMetricTable } from "../shared/AdminHotelsMetricTable";

type AdminOperationsHotelsTableProps = {
  rows: AdminHotelMetricRow[];
  loading?: boolean;
};

export const AdminOperationsHotelsTable = ({
  rows,
  loading = false,
}: AdminOperationsHotelsTableProps): React.JSX.Element => {
  const { t } = useTranslation();
  const columns = React.useMemo(
    () => getAdminTabMetricColumns("operations"),
    [],
  );

  return (
    <AdminHotelsMetricTable
      tab="operations"
      columns={columns}
      rows={rows}
      loading={loading}
      emptyMessage={t(
        "analytics.admin.operations.table.empty",
        "No operations data for the selected period.",
      )}
    />
  );
};
